<template>
  <div class="checkbox-input clearfix">
    <div class="form-group">
      <label v-bind:for="field.name" class="col-sm-4 control-label">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <div class="checkbox">
          <label>
            <input v-bind:id="field.name" type="checkbox" v-model="field.value" v-bind:name="field.name"/>
            <i v-if="field.icon" v-bind:class="'fa ' + field.icon + ' fa-lg'"></i> {{ field.checkboxLabel }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CheckboxInput.vue?99079336